

















import Vue from 'vue';
import { BButton } from 'bootstrap-vue';
import { updateObjectStatus } from '@/utils/crudActions';

export default Vue.extend({
  name: 'ObjectReview',
  components: { BButton },
  props: {
    url: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    reviewId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    btnObjectTypeTitle: {
      type: String,
      required: true,
    },
    msgApprove: {
      type: String,
      required: true,
    },
    msgDecline: {
      type: String,
      required: true,
    },
  },
  methods: {
    async changeState(newStatus: string) {
      try {
        await this.updateObjectStatus(this.url, this.csrfToken, newStatus, this.reviewId);

        this.showSuccessMsg(newStatus);
        this.reload();
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: 'Oops, something went wrong. Please try again or refresh your page.',
        });
      }
    },
    async confirmDecline() {
      const confirmation = await window.GGRC.zenModal.confirm(
        `If you decline the ${this.objectType} it will be assigned ` +
          'to the assignee again. You cannot undo this action. Do you want to ' +
          'proceed?',
        'Warning!'
      );

      if (confirmation) {
        this.changeState('Declined');
      }
    },
    successMsg(newStatus: string) {
      return newStatus == 'Approved' ? this.msgApprove : this.msgDecline;
    },
    showSuccessMsg(newStatus: string) {
      const msg = this.successMsg(newStatus);
      const notifyFn = window.GGRC.zenModal.visible ? 'Notify' : 'NotifyNextLoad';
      window.GGRC[notifyFn]({
        type: 'success',
        message: msg,
      });
    },
    reload() {
      if (window.GGRC.zenModal.visible) {
        window.GGRC.zenModal.$emit('reload');
      } else {
        window.location.reload();
      }
    },
    updateObjectStatus,
  },
});
